/**
 * MusicCredits
 *
 * Every bundled mood track is CC-BY, and the license requires a visible
 * credit. Driven by MUSIC_CREDITS, so a track added to the manifest with an
 * attribution shows up here without touching this file. Shared by the GM's
 * Foley Board and the players' sound popover.
 */

import { MOODS, MUSIC_CREDITS, type MusicTrack } from '../audio/trackManifest';

const SILVER = 'rgba(192,192,192,0.7)';
const SILVER_DIM = 'rgba(192,192,192,0.45)';
const GOLD = '#d4af37';

export function MusicCredits({ maxHeight = 260, highlightId }: { maxHeight?: number; highlightId?: string | null }) {
  return (
    <div style={{ maxHeight, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 10, paddingRight: 4 }}>
      {MOODS.map((mood) => {
        const tracks = MUSIC_CREDITS.filter((t) => t.moodId === mood.id);
        if (tracks.length === 0) return null;
        return (
          <div key={mood.id}>
            <div style={{ fontSize: 9, fontWeight: 600, color: mood.color, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 4 }}>
              {mood.label}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {tracks.map((track) => (
                <CreditLine key={track.id} track={track} highlighted={track.id === highlightId} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function CreditLine({ track, highlighted = false }: { track: MusicTrack; highlighted?: boolean }) {
  return (
    <div style={{ fontSize: 10, lineHeight: 1.4 }}>
      <div style={{ color: highlighted ? GOLD : SILVER }}>
        <span style={{ fontWeight: 600 }}>{track.title}</span>
        {track.artist && <> &middot; {track.artist}</>}
        {track.license && <span style={{ color: SILVER_DIM }}> &middot; {track.license}</span>}
      </div>
      <div style={{ color: SILVER_DIM, fontSize: 9, overflowWrap: 'anywhere' }}>
        {track.attribution}
        {track.sourcePage && (
          <>
            {' '}
            <a
              href={track.sourcePage}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: SILVER, textDecoration: 'underline' }}
            >
              Source
            </a>
          </>
        )}
      </div>
    </div>
  );
}
